<template>
  <g ref="xAxis"></g>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'xAxis',
  props: ['scale', 'format', 'tickValues'],
  mounted: function () {
    this.redraw()
  },
  methods: {
    redraw: function () {
      d3.select(this.$refs.xAxis).call(this.axis).attr('class', 'bottom-axis')
    },
  },
  computed: {
    axis: function () {
      let out = d3.axisBottom(this.scale).ticks(5).tickFormat(this.format)
      if (this.tickValues) {
        out.tickValues(this.tickValues)
      }
      return out
    },
  },
  watch: {
    scale: function () {
      this.redraw()
    },
    format: function () {
      this.redraw()
    },
  },
}
</script>

<style scoped>
</style>
